import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import logo from 'aurora-images/adgm-logo.svg';
import classNames from 'classnames';
import styles from './style';

const PaymentInvoice = props => {
  const { classes } = props;
  useEffect(() => {
    console.log('inside email template');
  }, []);
  return (
    <>
      <div className={classes.container}>
        <header className={classes.header}>
          <img src={logo} alt='logo' />
          <div className={classes.headerContent}>
            <div>Payment receipt</div>
            <div>Service : Off plan buy and sell </div>
          </div>
        </header>
        <hr className={classes.hr} />
        <main className={classes.main}>
          <div className={classes.details}>
            <span>Application number: </span>
            <span className={classes.value}>8736246234</span>
          </div>
          <div className={classes.details}>
            <span>Transaction ID: </span>
            <span className={classes.value}>90328743</span>
          </div>
          <div className={classes.details}>
            <span>Receipt date: </span>
            <span className={classes.value}>2/09/2021</span>
          </div>
          <div className={classes.headingDiv}>
            <div>Description</div>
            <div>
              Amount in AED
              <div>المبلغ بالدرهم</div>
            </div>
            <div>الوصف</div>
          </div>
          <div className={classes.boxDiv}>
            <div className={classes.boxDivContent}>
              <div>Municipality service charges</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 300</div>
              <div>رسوم الخدمات البلدية</div>
            </div>
            <div className={classes.boxDivContent}>
              <div>VAT 5%</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 30</div>
              <div>ضريبة القيمة المضافة 5%</div>
            </div>
            <hr className={classes.boxHr1} />
            <div className={classes.boxDivContent}>
              <div>Electronic administrative services allowance</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 50</div>
              <div>رسوم الخدمات البلدية</div>
            </div>
            <div className={classes.boxDivContent}>
              <div>VAT 5%</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 30</div>
              <div>ضريبة القيمة المضافة 5%</div>
            </div>
            <hr className={classes.boxHr2} />
            <div className={classes.boxDivContent}>
              <div className={classes.fontW500}>Total amount (Including VAT)</div>
              <div className={classNames(classes.Price, classes.fontW600)}>AED 382.50</div>
              <div className={classes.fontW700}>المبلغ الإجمالي (بما في ذلك ضريبة القيمة المضافة)</div>
            </div>
          </div>
        </main>
        <footer className={classNames(classes.footer, classes.invoiceFooter)}>
          <hr className={classes.hr} />
          <div className={classes.invoiceFooterDetails}>
            <span>ADRES</span>
            <span>Al Dar Hq, Abu Dhabi, UAE</span>
            <span>600523333</span>
            <span>Support@accessrp.adgm.com</span>
          </div>
        </footer>
      </div>
    </>
  );
};

PaymentInvoice.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(PaymentInvoice);
